import Icon from "./IconBase.js";
const PackageSelectIcon = (props) => {
  return (
    <Icon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="4.16667" fill="#EBF8FF" />
        <path
          d="M15.9131 7.6999L8.44651 10.9833C8.37002 11.0181 8.31794 11.1027 8.31988 11.1886V20.8198C8.32047 20.9033 8.37211 20.9843 8.44651 21.0182L15.9131 24.3016C15.9674 24.3263 16.032 24.3263 16.0865 24.3016L23.5531 20.7992C23.6275 20.7653 23.6792 20.6843 23.6797 20.6008V11.1881C23.6817 11.1023 23.6296 11.0178 23.5531 10.9828L16.0865 7.69943C16.0353 7.6724 15.9637 7.67515 15.9131 7.69943V7.6999ZM15.9997 8.14448L17.8731 8.96537L11.1265 12.0231L9.17974 11.1406L15.9997 8.14448ZM18.4131 9.20468L20.5198 10.1282L13.5667 13.3912C13.4902 13.426 13.4382 13.5106 13.4401 13.5964V17.2493L12.5535 15.8812C12.4967 15.7929 12.3724 15.7587 12.2801 15.8059L11.3068 16.3053V12.4267L18.4131 9.20468ZM21.0532 10.3675L22.9198 11.1884L15.9999 14.2256L14.3799 13.4936L21.0532 10.3675ZM8.74656 11.4279L10.8799 12.3923V16.661C10.8833 16.8068 11.0588 16.9163 11.1866 16.8525L12.3 16.2847L13.4733 18.0906C13.5714 18.2487 13.8656 18.1618 13.8666 17.9744V13.7472L15.7865 14.6159V23.7616L8.74659 20.6697L8.74656 11.4279ZM23.2531 11.5168V16.859C22.2999 17.3097 21.3464 17.7621 20.3932 18.2136C20.2785 18.2504 20.2108 18.402 20.2599 18.5146C20.309 18.627 20.4634 18.6737 20.5666 18.6103L23.2531 17.338V18.6034L21.2464 19.5201C21.1435 19.5667 21.0944 19.7085 21.1397 19.8142C21.1851 19.9199 21.3168 19.9702 21.4198 19.9237L23.2531 19.0892V20.4573L16.2132 23.7545V14.6155L23.2531 11.5168Z"
          fill="#008DC4"
        />
      </svg>
    </Icon>
  );
};
export default PackageSelectIcon;
